import React, { useEffect, FC } from 'react'
import { useController } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { MultiSelectCombobox } from '../../../../legacy-design-system/combobox'
import { useApplicationsQuery } from '../api/use-applications-query'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { useJiraIntegrationPage } from './jira-integration-page.provider'

export const ApplicationField: FC = () => {
  const { formatMessage } = useIntl()

  const {
    state: { organizationUuid }
  } = useJiraIntegrationPage()

  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.APPLICATIONS })

  const { applications } = useApplicationsQuery({
    organizationUuid
  })

  useEffect(() => {
    if (typeof value[0] === 'string' && applications) {
      onChange(
        value
          .map((val) =>
            applications.find((application) => application.appId === val)
          )
          .filter((val) => val) // remove any empty applications due to a mismatch
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applications])

  return (
    <MultiSelectCombobox
      values={value || []}
      label=""
      placeHolderTag={formatMessage(
        { id: 'variable_allApplications' },
        { count: applications?.length || 0 }
      )}
      items={[
        {
          items: applications ?? []
        }
      ]}
      itemToString={(item) => item.name}
      renderLabel={() => undefined}
      onChange={onChange}
      data-testid="application-multi-select"
    />
  )
}
